// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';
import ColorConstants from 'constants/ColorConstants';

function PageLoadingComponent({ containerStyle = {} }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...containerStyle
      }}
      aria-label="Loading"
      role="status"
    >
      <ClipLoader
        color={ColorConstants.ACTIVE_BUTTON_BLUE}
        sizeUnit={"px"}
        size={19}
        loading={true}
      />
    </div>
  );
}

export default PageLoadingComponent;
